// Input Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlUtil from '../../../lib/intlutil.jsx'

class Input extends Component {
  constructor (props) {
    super(props)

    this._references = {
      input: React.createRef()
    }
  }

  static get propTypes () {
    return {
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.string,
      className: PropTypes.string,
      styleType: PropTypes.oneOf([
        'normal',
        'transparent',
        'fieldinput',
        'filterinput',
        'headerinput',
        'searchinput'
      ]),
      maxLength: PropTypes.number,
      autoFocus: PropTypes.bool,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onKeyDown: PropTypes.func,
      isNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      name: '',
      placeholder: '',
      type: 'text',
      value: '',
      className: '',
      styleType: 'normal',
      autoFocus: false,
      onFocus: null,
      onBlur: null,
      onChange: null,
      onKeyDown: null,
      isNumber: false
    }
  }

  render () {
    const {
      name,
      type,
      value,
      maxLength,
      autoFocus,
      placeholder,
      className,
      styleType,
      isNumber,
      ...others
    } = this.props
    const _className = classnames('cinput', `cinput_${styleType}`, className, {
      cinput_number: isNumber
    })

    return (
      <div className={_className}>
        <input
          ref={this._references.input}
          name={name}
          type={type}
          value={value}
          maxLength={maxLength}
          autoFocus={autoFocus}
          placeholder={placeholder ? IntlUtil.convertMessage(placeholder) : ''}
          autoComplete='off'
          {...others}
          onChange={this._onChange.bind(this)}
          onBlur={this._onBlur.bind(this)}
          onFocus={this._onFocus.bind(this)}
        />
      </div>
    )
  }

  focus () {
    if (this._references.input.current) {
      this._references.input.current.focus()
    }
  }

  /* Event handlers */
  _onChange (event) {
    const { onChange, maxLength } = this.props
    const valueFromEvent = event.target.value

    const haveToTrim = maxLength && event.target.value.length > maxLength
    const value = haveToTrim
      ? valueFromEvent.substr(0, maxLength)
      : valueFromEvent

    if (onChange) {
      onChange(value || '', event)
    }
  }

  _onFocus (ev) {
    ev.preventDefault()

    // to set the cursor pointer to the end
    var value = ev.target.value
    ev.target.value = ''
    ev.target.value = value

    if (value === 0 || value === '0') {
      ev.target.select()
    }

    if (this.props.onFocus) {
      this.props.onFocus(ev)
    }
  }

  _onBlur (ev) {
    ev.preventDefault()

    if (this.props.onBlur) {
      this.props.onBlur(ev)
    }
  }
}

export default Input
